import type {
  BreadcrumbDividerSlots as BreadcrumbDividerBaseSlots,
  BreadcrumbDividerBaseProps,
  BreadcrumbDividerBaseState,
} from '@fluentui/react-breadcrumb';

/**
 * BreadcrumbDivider component slots
 */
export type BreadcrumbDividerSlots = BreadcrumbDividerBaseSlots;

/**
 * BreadcrumbDivider component props
 */
export type BreadcrumbDividerProps = BreadcrumbDividerBaseProps;

/**
 * BreadcrumbDivider component state
 */
export type BreadcrumbDividerState = BreadcrumbDividerBaseState;
